import useLeadsDataTable from "features/leads/hooks/useLeadsDataTable";

import BulkManageDesktop from "common/components/BulkManageDesktop";
import { DataTable } from "common/components/DataTable";
import type { Lead } from "common/types";

import { MANAGE_LEADS_ACTIONS } from "../../../constants";
import AddNotes from "../ManageLeads/AddNotes";
import FavoriteLeads from "../ManageLeads/FavoriteLeads";
import UpdateLabels from "../ManageLeads/UpdateLabels";

import type { VisibilityState } from "@tanstack/react-table";

interface DesktopTableProps {
  leads: Lead[];
  selectedLeads: Lead[];
  setSelectedLeads: (selectedLeads: Lead[]) => void;
  openSidebar: (leadId: string, action: "preview" | "notes") => void;
  isLoading: boolean;
  pageSize: number;
  totalItemCount: number;
  columnVisibility: VisibilityState;
  setColumnVisibility: (columnVisibility: VisibilityState) => void;
}

export default function DesktopTable({
  leads,
  selectedLeads,
  setSelectedLeads,
  openSidebar,
  isLoading,
  pageSize,
  totalItemCount,
  columnVisibility,
  setColumnVisibility,
}: DesktopTableProps) {
  const table = useLeadsDataTable({
    leads,
    selectedLeads,
    setSelectedLeads,
    openSidebar,
    isLoading,
    pageSize,
    columnVisibility,
    setColumnVisibility,
  });

  return (
    <DataTable
      table={table}
      onRowClick={({ id }) => openSidebar(id, "preview")}
      totalItemCount={totalItemCount}
      isLoading={isLoading}
      selectionActionsComponent={
        <BulkManageDesktop
          actions={MANAGE_LEADS_ACTIONS}
          selection={selectedLeads}
          clearSelection={() => setSelectedLeads([])}
          renderActionComponent={({ action, onClose }) => {
            const commonProps = {
              selectedLeads,
              onClose,
            };
            if (action === "labels") {
              return <UpdateLabels {...commonProps} />;
            }
            if (action === "notes") {
              return <AddNotes {...commonProps} />;
            }
            return <FavoriteLeads action={action} {...commonProps} />;
          }}
        />
      }
    />
  );
}
